'use client';

import SectionTitle from '@/components/section-title/section-title';
import { useLocale, useTranslations } from 'next-intl';
import Image from 'next/image';
import { featuresVashaAcademy } from '../features';

export default function FeaturesSection() {
  const t = useTranslations();
  const locale = useLocale();

  const renderFeatureCard = (feature: any, index: number) => {
    const isEven = index % 2 === 0;

    return (
      <div key={feature.id} className="relative mb-16 lg:mb-24">
        <div
          className={`flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-16`}
        >
          <div className="w-full lg:w-1/2 flex justify-center">
            <div className="relative group cursor-pointer transform transition-transform duration-500 hover:scale-105 rounded-md">
              <div className="relative bg-white/95  rounded-xl overflow-hidden">
                <div className="relative">
                  <div className="w-40 h-40 lg:w-56 lg:h-56 mx-auto relative">
                    <Image
                      src={feature.icon || '/placeholder.svg'}
                      width={400}
                      height={400}
                      alt={`${feature.titleKey} feature icon`}
                      className="w-full h-full object-contain relative z-10 transition-transform duration-300 group-hover:scale-105"
                      priority={index < 2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 text-center lg:text-left space-y-6">
            <div className="space-y-3">
              <h3 className={`text-4xl lg:text-5xl font-bold text-white`}>
                {t(feature.titleKey)}
              </h3>
            </div>

            <p className="text-gray-300 leading-relaxed text-lg lg:text-xl max-w-lg mx-auto lg:mx-0 transition-colors duration-300 hover:text-white">
              {t(feature.descriptionKey)}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="relative bg-gradient-to-br from-[#02302B] via-[#024239] to-[#02302B] overflow-hidden">
      <div className="container relative z-10 py-20 lg:py-32">
        <div className="text-center mb-20 lg:mb-32 max-w-4xl mx-auto">
          <div className="relative">
            <div className="transition-transform duration-300 hover:scale-105">
              <SectionTitle className="text-white mb-8" align="center">
                {t('vasha-academy-home-page.feature-section.title')}
              </SectionTitle>
            </div>

            <p className="text-gray-300 text-xl leading-relaxed max-w-2xl mx-auto transition-colors duration-300 hover:text-white">
              {t('vasha-academy-home-page.feature-section.description')}
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto">
          {featuresVashaAcademy.map((feature, index) =>
            renderFeatureCard(feature, index),
          )}
        </div>
      </div>
    </section>
  );
}
